import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import moment from 'moment/min/moment-with-locales.min';
import Slider from 'react-slick';
import CalendarOfficeHours from './calendar-office-hours';
import SponsoredDay from '../../../sponsored-day';
import EventDay from '../../../event-day';

class CalendarMini extends Component {
  constructor(props) {
    moment.locale(props.i18n.language)

    // Build days array for the slider with -30 and +365 days from now.
    // There is probably a more elegant/dynamic way to do this.
    const daysForSlider = () => {
      const days = []
      const today = moment()
      const dateStart = moment().subtract(30, 'days');
      const dateEnd = moment().add(365, 'days')

      while (dateEnd.diff(dateStart, 'days') >= 0) {
        let dayData = {
          date: dateStart.format('YYYY-MM-DD'), // Needed for: matching to day "type", to show correct opening times
          dateDayNumber: dateStart.format('DD'), // Needed for: sliderDaysOverview
          dateDayName: dateStart.format('ddd'), // Needed for: sliderDaysOverview
          dateMonthAndYear: dateStart.format('MMMM YYYY'), // Needed for: sliderMonth
          isToday: false // Needed for: sliderDaysOverview to display "today" as string instead of the date
        }

        if (moment(dateStart).isSame(today, 'day')) {
          dayData.isToday = true
        }

        days.push(dayData)
        dateStart.add(1, 'days')
      }
      return days
    }

    super(props);
    this.state = {
      navMonth: null,
      navDaysOverview: null,
      days: daysForSlider(),
      selectedDay: 30
    }
  }

  componentDidMount() {
    this.setState({
      navMonth: this.sliderMonth,
      navDaysOverview: this.sliderDaysOverview
    });

    this.sliderMonth.slickGoTo(30)
  }

  render() {
    const sliderDaysOverviewSettings = {
      slidesToShow: 7,
      swipeToSlide: true,
      focusOnSelect: true,
      centerMode: true,
      arrows: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    }
    // This slider was originally intended to be a day slider, highlighting the current day.
    // Later it was decided to turn it into a month slider. So here we simply scroll 30 slides at once, as a simple but good-enough workaround.
    const sliderMonthSettings = {
      infinite: false,
      slidesToScroll: 30,
      speed: 0, // disable animation.
      afterChange: (current) => this.setState({ selectedDay: current })
    }

    return (
      <div className="container text-center">
        <div className="row">
          <section className="paragraph-calendar-mini-section mb-5">
            <Slider
              {... sliderDaysOverviewSettings}
              ref={slider => (this.sliderDaysOverview = slider)}
              asNavFor={this.state.navMonth}
            >
              {this.state.days.map((item, index) =>
                <div key={index}>
                  <p>
                    {!item.isToday &&
                      <span className="dayName d-inline-block">{item.dateDayName.slice(0, -1)}</span>
                    }
                    <span className="dayNumber d-inline-block">{item.isToday ? this.props.t('Heute') : item.dateDayNumber}</span>
                  </p>
                </div>
              )}
            </Slider>
            <EventDay date={this.state.days[this.state.selectedDay].date} />
            <CalendarOfficeHours selectedDay={this.state.days[this.state.selectedDay].date} />
            <Slider
              {... sliderMonthSettings}
              asNavFor={this.state.navDaysOverview}
              ref={slider => (this.sliderMonth = slider)}
            >
              {this.state.days.map((item, index) =>
                <div key={index}>
                  <span className="btn h3 bg-unikatum-cyan text-white">{item.dateMonthAndYear}</span>
                </div>
              )}
            </Slider>
            <SponsoredDay date={this.state.days[this.state.selectedDay].date} />
            <div className="mt-5">
              <a href={"/" + this.props.i18n.language + "/node/36"} className="btn btn-cta h3">» {this.props.t('Hier Tickets buchen!')}</a>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CalendarMini);
